export const siteSettings = {
  name: "Veyrion Trade",
  link: "https://veyriontrade.com",
  email: "support@veyriontrade.com",
  appLink: "https://app.veyriontrade.com",
};
